import { urlParamsToMap } from './urls'

export const getApiUrl = () => {
    const isRunningLocally =
        window.location.port === '3000' ||
        window.location.port === '3001' ||
        window.location.port === '3002'
    return isRunningLocally ? 'http://localhost:8003/it-api' : '/it-api'
}

const config = {
    baseUrl: getApiUrl(),
}

const getSessionId = (): string => {
    const params = urlParamsToMap(window.location.search)
    if (params.token) {
        const token = params.token
        if (!token) {
            return ''
        }
        localStorage.setItem('MagnoToken', token)
        return token
    }
    return localStorage.getItem('MagnoToken') || ''
}

export const authedGet = async (path: string) => {
    const result = await fetch(`${config.baseUrl}/${path}`, {
        method: 'GET',
        headers: {
            'X-authenticated': getSessionId(),
        },
    })
    return result
}

const authedMutate = async (method: string, path: string, body: object) => {
    const result = await fetch(`${config.baseUrl}/${path}`, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'X-authenticated': getSessionId(),
        },
        body: JSON.stringify(body),
    })
    return result
}

export const authedDelete = async (path: string, body: object) => {
    return await authedMutate('DELETE', path, body)
}

export const authedPut = async (path: string, body: object) => {
    return await authedMutate('PUT', path, body)
}

export const authedPost = async (path: string, body: object) => {
    return await authedMutate('POST', path, body)
}
